import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const brex = defineConnector({
  identifier: "brex",
  name: "Brex",
  tagLine: "Corporate card and spend",
  keywords:
    "corporate card spend expenses transactions reimbursements brexapis",
  logo,
  protocol: "http",
  tags: ["productivity", "data"],
  defaultUrlPattern: () => "https://platform\\.brexapis\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Brex developer app",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to the [Brex Developer Portal](https://developer.brex.com/) and create a new OAuth application.",
        },
      ],
    },
    {
      title: "Configure OAuth redirect URI",
      items: [
        {
          kind: "markdown",
          content: "Add the following redirect URI to your Brex app:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/brex/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Copy the Client ID and Client Secret from your Brex application.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Define scopes",
      items: [
        {
          kind: "markdown",
          content:
            "Add [scopes](https://developer.brex.com/docs/scopes/) in a space separated list below. Common scopes include `openid offline_access`.",
        },
        {
          kind: "input",
          label: "Scopes (optional)",
          placeholder: "openid offline_access",
          helperText: "Space separated list of desired scopes.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
    {
      title: "Authorize your Brex account",
      items: [
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://accounts-api.brex.com/oauth2/default/v1/authorize",
    tokenEndpoint: () =>
      "https://accounts-api.brex.com/oauth2/default/v1/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://platform.brexapis.com/v2/users/me",
  },
});
